/**
 * @description 是否包含本地缓存对象
 */
let hasLocalStorage = () => {
    return window.localStorage ? true : false;
};

/**
 *
 * @param {string} key
 * @param {any} value
 * @description 设置缓存
 */
let setLocalStorage = (key, value) => {
    if (!value) return;
    if (hasLocalStorage) {
        window.localStorage.setItem(key, value);
    }
};

/**
 *
 * @param {string} key
 * @description 获取缓存
 */
let getLocalStorage = (key) => {
    if (typeof key === "string" && key.length > 1 && hasLocalStorage) {
        return window.localStorage.getItem(key);
    }
};

export { setLocalStorage, getLocalStorage };
